import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'when_productionvolume_is_lower_than_expected_how_are_wrkrs_impa'

export const dataPointDefinition = {
  retracedId: 'when_productionvolume_is_lower_than_expected_how_are_wrkrs_impa',
  name: 'When production/volume is lower than expected, how are workers impacted?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'NO_IMPACT_TO_WORKERS_WORKERS_RECEIVE_THEIR_REGULAR_PAY_AND_COME',
      text: 'No impact to workers (workers receive their regular pay and come to work) ',
      externalIds: [
        {
          id: 'wh-ove-7',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_MUST_STAY_AT_HOME_AND_ARE_REQUIRED_TO_USE_VACATION_TIME',
      text: 'Workers must stay at home and are required to use vacation time/paid time off',
      externalIds: [
        {
          id: 'wh-ove-8',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKER_S_HOURS_ARE_REDUCED',
      text: "Worker's hours are reduced",
      externalIds: [
        {
          id: 'wh-ove-9',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_MUST_STAY_AT_HOME_AND_ARE_PAID_LEGAL_MINIMUM_WAGE',
      text: 'Workers must stay at home and are paid legal minimum wage',
      externalIds: [
        {
          id: 'wh-ove-10',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_MUST_STAY_AT_HOME_AND_ARE_PAID_LESS_THAN_LEGAL_MINIMUM_',
      text: 'Workers must stay at home and are paid less than legal minimum wage',
      externalIds: [
        {
          id: 'wh-ove-11',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_MUST_STAY_AT_HOME_AND_ARE_NOT_PAID',
      text: 'Workers must stay at home and are not paid',
      externalIds: [
        {
          id: 'wh-ove-12',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER_ACTION_IMPACTING_WORKERS',
      text: 'Other action impacting workers',
      externalIds: [
        {
          id: 'wh-ove-13',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'wh-ove-14f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'NO_IMPACT_TO_WORKERS_WORKERS_RECEIVE_THEIR_REGULAR_PAY_AND_COME',
                'WORKERS_MUST_STAY_AT_HOME_AND_ARE_REQUIRED_TO_USE_VACATION_TIME',
                'WORKER_S_HOURS_ARE_REDUCED',
                'WORKERS_MUST_STAY_AT_HOME_AND_ARE_PAID_LEGAL_MINIMUM_WAGE',
                'WORKERS_MUST_STAY_AT_HOME_AND_ARE_PAID_LESS_THAN_LEGAL_MINIMUM_',
                'WORKERS_MUST_STAY_AT_HOME_AND_ARE_NOT_PAID',
                'OTHER_ACTION_IMPACTING_WORKERS',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wh-ove-6',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7060,
  sectionId: '2.2.12',
  impactArea: 'Working Hours',
  impactAreaId: 'WORKING_HOURS_AND_OVERTIME',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
